import React from 'react'
import htmlContent from '../../../utils/termsandconditions'
import dompurify from 'dompurify'

// import image from '../../../assets/logos/logo_finger_print.png'

const ContractBulletItemPure = (props) => {
  var sanitizer = dompurify.sanitize
  // let { description } = props.dataItem
  // let id = props.index + 1
  return (
    <div className='contract-bullet-item'>
      <div>
        {/* <img alt='hibou.legal Logo :)' src={image} width={50}/> */}
      </div>
      <div className='contract-bullet-item-name'>
        <div className='list-item'>
          <div className='contract-item'>
            <div dangerouslySetInnerHTML={{ __html: sanitizer(htmlContent) }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export { ContractBulletItemPure as default }